import * as BECaller from '../../util/apiCaller';
import { setError } from '../App/ErrorsActions';

export const CONSENT_LOADING = 'consent_loading';
export const CONSENT_DATA = 'consent_data';
export const CONSENT_ERROR = 'consent_error';
export const CONSENT_SUBMITTING = 'consent_submitting';

export function handleError(error, opt) {
  return setError(error, opt);
}

export function getConsentData(id) {
  return (dispatch) => {
    dispatch({ type: CONSENT_LOADING });
    return BECaller.api(`consent/${id}`).then(
      (response) => dispatch({ type: CONSENT_DATA, payload: response }),
      (err) => {
        dispatch(handleError(err));
        dispatch({ type: CONSENT_ERROR, payload: err.message });
      },
    );
  };
}

export function approveConsent(id) {
  return (dispatch) => {
    dispatch({ type: CONSENT_SUBMITTING, payload: true });
    return BECaller.api(`consent/${id}/approve`, 'post').then(
      () => true,
      (err) => {
        dispatch(handleError(err));
        dispatch({ type: CONSENT_ERROR, payload: err.message });
        return false;
      },
    );
  };
}

export function denyConsent(id) {
  return (dispatch) => {
    dispatch({ type: CONSENT_SUBMITTING, payload: true });
    return BECaller.api(`consent/${id}/deny`, 'post').then(
      () => true,
      (err) => {
        dispatch(handleError(err));
        dispatch({ type: CONSENT_ERROR, payload: err.message });
        return false;
      },
    );
  };
}
